import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _ASSET_TYPE_VS_CAN_VI;

import _split from 'lodash/split';
import _head from 'lodash/head';
import _once from 'lodash/once';
import _includes from 'lodash/includes';
import _stubTrue from 'lodash/stubTrue';
import _stubFalse from 'lodash/stubFalse';
import extVsMime from '../constants/ExtensionVsMIME';
import { FILE_EXTENSIONS } from '../constants/downloadFileType';
export var BROWSER_ASSET_TYPE = {
  video: 'video',
  image: 'image',
  audio: 'audio'
};
var TRANSFER_PROTOCOL = {
  HTTP: 'http',
  BLOB_HTTP: 'blob:http'
};
var CUSTOM_MIME_TYPE_SUPPORT = {
  video: ['video/mov', 'video/quicktime'],
  image: []
};

var getVidoElem = _once(function () {
  return document.createElement('video');
});

var ASSET_TYPE_VS_CAN_VIEW = (_ASSET_TYPE_VS_CAN_VI = {}, _defineProperty(_ASSET_TYPE_VS_CAN_VI, BROWSER_ASSET_TYPE.video, function (contentType, assetType) {
  return _includes(CUSTOM_MIME_TYPE_SUPPORT[assetType], contentType) || !!getVidoElem().canPlayType(contentType);
}), _defineProperty(_ASSET_TYPE_VS_CAN_VI, BROWSER_ASSET_TYPE.image, _stubTrue), _defineProperty(_ASSET_TYPE_VS_CAN_VI, BROWSER_ASSET_TYPE.audio, _stubTrue), _defineProperty(_ASSET_TYPE_VS_CAN_VI, "DEFAULT", _stubFalse), _ASSET_TYPE_VS_CAN_VI);

var FILE_EXTENSION_VS_CAN_VIEW = _defineProperty({}, FILE_EXTENSIONS.PDF, _stubTrue);

export var canViewAsset = function canViewAsset(contentType) {
  var _split2 = _split(contentType, '/'),
      _split3 = _slicedToArray(_split2, 2),
      assetType = _split3[0],
      fileExtension = _split3[1];

  return (ASSET_TYPE_VS_CAN_VIEW[assetType] || FILE_EXTENSION_VS_CAN_VIEW[fileExtension] || ASSET_TYPE_VS_CAN_VIEW.DEFAULT)(contentType, assetType);
};
export var isImage = function isImage(contentType) {
  var assetType = _head(_split(contentType, '/'));

  return assetType === BROWSER_ASSET_TYPE.image;
};
export var isVideo = function isVideo(contentType) {
  if (contentType === extVsMime.webm2) return true;

  var assetType = _head(_split(contentType, '/'));

  return assetType === BROWSER_ASSET_TYPE.video;
};
export var isHTTP = function isHTTP(url) {
  var protocol = _head(_split(url, ':'));

  return protocol === TRANSFER_PROTOCOL.HTTP;
};
export var isHTTPBlob = function isHTTPBlob(url) {
  return _includes(url, TRANSFER_PROTOCOL.BLOB_HTTP);
};